import Buscador from "./Buscador"
export default Buscador;